module.exports = __webpack_public_path__ + "img/phone-ico-black.237f46b3.png";